module.exports = __webpack_public_path__ + "img/preview-7.ed3e33b2.webp";